import { render, staticRenderFns } from "./AppUndoConfirmation.vue?vue&type=template&id=48317df2&scoped=true&"
import script from "./AppUndoConfirmation.vue?vue&type=script&lang=js&"
export * from "./AppUndoConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AppUndoConfirmation.vue?vue&type=style&index=0&id=48317df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48317df2",
  null
  
)

export default component.exports